export default class Share {
	constructor(options) {
		this.url = options.shareUrl;
		this.title = options.shareTitle;
		this.text = options.shareText;

	}

	async share(url, text, title) {
		if (!url) {
			url = this.url;
		}

		if (!title) {
			title = this.title;
		}

		if (!text) {
			text = this.text;
		}

		if (typeof FBInstant != 'undefined') {
			const base64Data = await this.readAsDataURL('./assets/Icons/Icon_512x512.png');
			globalThis.FBInstant.shareAsync({
				image: base64Data,
				text: text,
				data: {},
			}).then(function () {
				// continue with the game.
			});
			return;
		}

		if (typeof navigator != 'undefined' && typeof navigator.share != 'undefined') {
			navigator.share({
				url: url,
				title: title,
				text: text,
			}).catch(function (_results) {

			});
			return;
		}

		// let facebook = new Facebook();
		// if (facebook.canUse()) {
		//     facebook.share(url, title, text);
		//     return;
		// }

		this.shareWeb(url);
	}

	shareWeb(url) {
		if (!url) {
			url = this.url;
		}

		const urlEncoded = encodeURI(url);
		const shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + urlEncoded + '&display=popup&ref=plugin&src=share_button';
		window.open(shareUrl, '_system');
		//window.location = url;
	}

	async readAsDataURL(file) {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.crossOrigin = 'anonymous';
			img.src = file;

			img.onload = () => {
				const canvas = document.createElement('canvas');
				canvas.width = img.width;
				canvas.height = img.height;
				const ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0);
				const base64data = canvas.toDataURL('image/jpeg');
				resolve(base64data);
			};

			img.onerror = () => {
				reject();
			};
		});
	}
}
